const Theme = {
  body_background_color: '#0F294F',
  title_font: 'Tercia',
  text_font: 'RM Neue',
  logo_image_url: 'saintsulpice.png',
  token_hidden: true,
  number_hidden: true,
  title_margin_left: 7,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 0,
  button_color: '#48ADCA',
  button_hover_text_color: '#48ADCA',
  button_radius: 10,
  button_outlined_border_color: '#48ADCA',
  button_outlined_hover_border_color: '#48ADCA'
}

export default Theme
